<template>
  <div id="root" :class="{ fullscreen: getIsFullscreen }">
    <the-header v-if="hasHeader" />
    <the-sidebar />
    <router-view class="view" />
    <the-cookie-banner />
    <the-footer v-if="hasFooter" />
  </div>
</template>

<script>
import TheFooter from "./components/organisms/the-footer";
import { mapGetters } from "vuex";
import TheCookieBanner from "./components/atoms/the-cookie-banner";
import { bootstrap } from "vue-gtag";
import TheHeader from "./components/organisms/the-header";
import TheSidebar from "./components/organisms/the-sidebar";
export default {
  components: {
    TheSidebar,
    TheHeader,
    TheCookieBanner,
    TheFooter
  },
  computed: {
    hasHeader() {
      return (
        !(this.$route.meta.header && this.$route.meta.header.hidden) &&
        this.getHasHeader
      );
    },
    hasFooter() {
      return !(this.$route.meta.footer && this.$route.meta.footer.hidden);
    },
    ...mapGetters({
      getIsFullscreen: "globals/getIsFullscreen",
      getHasHeader: "globals/getHasHeader"
    })
  },
  async mounted() {
    if (this.$cookies.get("accept-cookie-policy")) {
      await bootstrap();
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
#root {
  min-height: 100vh;
  width: 100%;
  position: relative;
  z-index: 10;
}
.fullscreen {
  height: 100vh;
}
</style>

<style lang="scss">
@import "~@/styles/global.scss";
body {
  margin: 0;
}
</style>
